import { CartItem } from "./CartItem";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import CartTotals from "./CartTotals";

const CartCheckOutList = ({ itemsInCart, cartQuantity }) => {

  // Calculate subtotal (excluding STC items)
  const subtotal = itemsInCart.reduce((total, cartItem) => {
    if (cartItem.stockcode === 'WS-H-STC-ASSIGNED') {
      return total; // Don't add STC items to subtotal
    }
    return total + (cartItem?.price || 0) * cartItem.quantity
  }, 0)

  // Calculate rebate amount from STC items
  const rebateAmount = itemsInCart.reduce((total, cartItem) => {
    if (cartItem.stockcode === 'WS-H-STC-ASSIGNED') {
      return total + (cartItem.quantity * 35); // $35 per STC certificate
    }
    return total;
  }, 0)

  return (

    <div className="card" style={{ width: '100%', marginTop: '63px' }}>
      <div className="mb-3 p-3 margin-0 bg-light border-bottom">
        <h4><ShoppingCartIcon /> Your Cart ({cartQuantity} Items)</h4>
      </div>

      <div className="card-body">
        {itemsInCart.map(item => (
          <CartItem key={item.id} {...item} />
        ))}

        <div className="p-4">
          <CartTotals subtotal={subtotal} rebateAmount={rebateAmount} />
        </div>
      </div>
    </div>

  );
};

export default CartCheckOutList;